module.exports = __webpack_public_path__ + "img/contact-card.ee8d103b.svg";